import React from "react";
import moment from "moment";
import { DatePicker, Form, Input, Modal } from "antd";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { EditDocumentIcon } from "../../../resource/icons";

import actions from "../store/actions/edit-document.actions";

const EditDoneDateModal = ({
	doneDate,
	visible,
	validateFields,
	getFieldDecorator,
	onCancel,
	prepareDataAndResetFields,
}) => {
	const dispatch = useDispatch();

	const onDoneDateChanged = useCallback(() => {
		validateFields((err, values) => {
			if (err) return;
			const v = prepareDataAndResetFields(values);
			dispatch(actions.updateDoneDate(v));
			dispatch(actions.closeModal());
		});
	}, [validateFields]);
	return (
		<Modal
			style={{ minWidth: 350 }}
			width={350}
			visible={visible}
			title={
				<span>
					<EditDocumentIcon
						style={{
							height: 40,
							verticalAlign: "middle",
							marginRight: 10,
						}}
					/>
					Дата ответа
				</span>
			}
			okText="Изменить"
			onCancel={onCancel}
			onOk={onDoneDateChanged}
		>
			<Form layout="vertical">
				<Form.Item label="Дата">
					{getFieldDecorator("changedDoneDate", {
						initialValue: doneDate ? moment(doneDate) : moment(),
						rules: [
							{
								required: true,
								message: "Пожалуйста, укажите дату ответа",
							},
						],
					})(<DatePicker allowClear={false} format="DD.MM.YYYY" />)}
				</Form.Item>

				<Form.Item label="Комментарий">
					{getFieldDecorator("changedDoneDateComment", {
						initialValue: "",
						rules: [
							{
								required: true,
								message: "Пожалуйста, укажите комментарий",
							},
						],
					})(<Input />)}
				</Form.Item>
			</Form>
		</Modal>
	);
};

export default EditDoneDateModal;
